export default __webpack_public_path__ + "static/media/greenhouse-illustration.462f3217.png";